import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=46a5df3c&scoped=true"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=46a5df3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5df3c",
  null
  
)

export default component.exports